// Shared soft-launch sizing rules — the single source of truth for the
// single-survey Confirmation page (ConfirmationSoftLaunch) and the
// multi-market Confirm page (MarketRow), so the default and the bounds can't
// drift between the two surfaces.

export const DEFAULT_SOFT_LAUNCH_COMPLETES = 100
export const MIN_SOFT_LAUNCH_COMPLETES = 1

/**
 * Default soft-launch size when the toggle is switched on: the start size
 * (100 completes) or, when the target is below it, 10% of the target —
 * never less than one complete.
 */
export const defaultSoftLaunchSamplesNeeded = (
  target: number,
  startNumOfCompletes: number = DEFAULT_SOFT_LAUNCH_COMPLETES
): number =>
  startNumOfCompletes < target
    ? startNumOfCompletes
    : Math.max(1, Math.ceil(target * 0.1))

/** A soft-launch size is valid when it fields at least `min` and at most the target. */
export const isSoftLaunchSamplesValid = (
  value: number,
  target: number,
  min: number = MIN_SOFT_LAUNCH_COMPLETES
): boolean => value >= min && value <= target

export const softLaunchSamplesErrorMessage = (
  target: number,
  min: number = MIN_SOFT_LAUNCH_COMPLETES
): string => `Number of completes must be between ${min} and ${target}`
